import { ChevronLeft, ChevronRight } from 'lucide-react'

function pageNumbers(current: number, total: number): (number | '...')[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)
  if (current <= 4) return [1, 2, 3, 4, 5, '...', total]
  if (current >= total - 3) return [1, '...', total - 4, total - 3, total - 2, total - 1, total]
  return [1, '...', current - 1, current, current + 1, '...', total]
}

export function TablePagination({
  page,
  totalPages,
  total,
  pageSize,
  start,
  onPage,
}: {
  page: number
  totalPages: number
  total: number
  pageSize: number
  start: number
  onPage: (p: number) => void
}) {
  if (total <= pageSize) return null

  const from = start + 1
  const to = Math.min(start + pageSize, total)
  const pages = pageNumbers(page, totalPages)

  const btnBase = 'inline-flex items-center justify-center h-7 min-w-7 px-1.5 rounded text-sm transition-colors'
  const btnActive = 'bg-indigo-600 text-white font-medium'
  const btnInactive = 'text-gray-600 hover:bg-gray-100 cursor-pointer'
  const btnDisabled = 'text-gray-300 cursor-not-allowed'

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-gray-100 text-sm">
      <span className="text-gray-400 text-xs">
        Showing {from}–{to} of {total}
      </span>
      <div className="flex items-center gap-0.5">
        <button
          onClick={() => onPage(page - 1)}
          disabled={page === 1}
          className={`${btnBase} ${page === 1 ? btnDisabled : btnInactive}`}
        >
          <ChevronLeft size={15} />
        </button>

        {pages.map((p, i) =>
          p === '...' ? (
            <span key={`ellipsis-${i}`} className="px-1 text-gray-400 text-xs select-none">…</span>
          ) : (
            <button
              key={p}
              onClick={() => onPage(p as number)}
              className={`${btnBase} ${p === page ? btnActive : btnInactive}`}
            >
              {p}
            </button>
          )
        )}

        <button
          onClick={() => onPage(page + 1)}
          disabled={page === totalPages}
          className={`${btnBase} ${page === totalPages ? btnDisabled : btnInactive}`}
        >
          <ChevronRight size={15} />
        </button>
      </div>
    </div>
  )
}
